<div class="as-signin-container">
  @if(!displayRestorePassword){
  <div class="as-signin-form">
    <form autocomplete="off" class="as-form-left" [formGroup]="signinForm">
      <mat-label class="as-font-24 as-font-bold">
        {{ 'AUTH.signin' | translate }}
      </mat-label>
      <br />
      <mat-form-field appearance="outline" color="accent">
        <mat-label> {{ 'AUTH.email' | translate }} </mat-label>
        <input matInput formControlName="email" />
        @if(signinForm.get('email')?.hasError('pattern')){
        <mat-error>
          {{ 'AUTH.ERROR.invalidEmail' | translate }}
        </mat-error>
        } @if(signinForm.get('email')?.hasError('notFound')){
        <mat-error>
          {{ 'AUTH.ERROR.notFound' | translate }}
        </mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" color="accent">
        <mat-label> {{ 'AUTH.password' | translate }} </mat-label>
        <input
          matInput
          type="{{ hide ? 'password' : 'text' }}"
          formControlName="password"
          (keyup)="onKeyUp()"
        />
        @if(signinForm.get('password')?.hasError('minlength')){
        <mat-error> {{ 'AUTH.passwordHint' | translate }}* </mat-error>
        } @if(signinForm.get('password')?.hasError('wrongPassword')){
        <mat-error> {{ 'AUTH.ERROR.wrongPassword' | translate }} </mat-error>
        } @if(signinForm.get('password')?.hasError('tooManyRequests')){
        <mat-error> {{ 'AUTH.ERROR.tooManyRequests' | translate }} </mat-error>
        }

        <button mat-icon-button matSuffix type="button" (click)="hide = !hide">
          <mat-icon svgIcon="ic-visible{{ hide ? '-off' : '' }}"></mat-icon>
        </button>
        @if(!signinForm.get('password')?.errors){
        <mat-hint class="as-font-12 as-font-medium as-font-green">
          {{ 'AUTH.passwordHint' | translate }}*
        </mat-hint>
        }
      </mat-form-field>
      <br />
      <button
        mat-flat-button
        color="accent"
        type="submit"
        [disabled]="!signinForm.valid"
        (click)="signin()"
      >
        <mat-label class="as-font as-font-semibold as-font-white">
          {{ 'AUTH.enter' | translate }}
        </mat-label>
      </button>
      <a
        class="as-forgot-password"
        (click)="displayRestorePassword = !displayRestorePassword"
      >
        {{ 'AUTH.forgotPassword' | translate }}
      </a>
    </form>
    <mat-divider [vertical]="true"></mat-divider>
    <div class="as-form-right">
      <button
        (click)="onLoginFacebook()"
        mat-flat-button
        class="as-facebook-button"
      >
        <mat-icon svgIcon="ic-fb"></mat-icon>
        <mat-label class="as-font as-font-white as-font-medium">
          {{ 'AUTH.facebookSignin' | translate }}
        </mat-label>
      </button>
      <br />
      <br />
      <div id="googleButton"></div>
      <br /><br />
      <div class="as-row as-justify-center">
        <mat-label class="as-font-14">
          {{ 'AUTH.dontHaveAccount' | translate }}
        </mat-label>
        <mat-label
          class="as-signup as-font-underline as-pointer"
          (click)="onNavigate('autenticacion/registro')"
        >
          {{ 'AUTH.signup' | translate }}
        </mat-label>
      </div>
    </div>
  </div>
  }@else{
  <div class="as-row as-icon-container">
    <mat-icon
      svgIcon="ic-close-gray"
      class="as-pointer"
      (click)="close()"
    ></mat-icon>
  </div>
  <form
    autocomplete="off"
    class="as-restore-form"
    [formGroup]="restorePasswordForm"
  >
    <mat-label class="as-font-20 as-font-bold as-font-black-gray">
      {{ 'AUTH.restorePassword' | translate }}
    </mat-label>
    <mat-label class="as-restore-hint">
      {{ 'AUTH.passwordForgotten' | translate }}
    </mat-label>
    <div class="as-email-sent-container">
      <mat-icon svgIcon="ic-orange-alert"></mat-icon>
      <mat-label class="as-email-sent-hint">
        {{ 'AUTH.passwordSentEmail' | translate }}
      </mat-label>
    </div>
    <mat-form-field appearance="outline" color="accent">
      <mat-label class="as-font-12 as-font-w-700 as-open-sans">
        {{ 'AUTH.email' | translate }}
      </mat-label>
      <input matInput formControlName="email" />
      @if(restorePasswordForm.get('email')?.hasError('pattern')){
      <mat-error>{{ 'AUTH.ERROR.invalidEmail' | translate }}</mat-error>
      } @if(restorePasswordForm.get('email')?.hasError('required')){
      <mat-error>
        {{ 'GENERAL.required' | translate }}
      </mat-error>
      } @if(restorePasswordForm.get('email')?.hasError('invalid')){
      <mat-error>
        {{ 'AUTH.ERROR.emailNotRegistered' | translate }}
      </mat-error>
      }
    </mat-form-field>
    <button
      mat-flat-button
      color="accent"
      type="button"
      (click)="sendEmailRestorePassword()"
      [disabled]="!restorePasswordForm.valid || loading"
    >
      <mat-label class="as-font-semibold as-font-white as-open-sans">
        {{ 'GENERAL.continue' | translate }}
      </mat-label>
    </button>
  </form>
  }
</div>
